import { render, staticRenderFns } from "./GroupedLabelItem.vue?vue&type=template&id=6d19f508&scoped=true"
import script from "./GroupedLabelItem.vue?vue&type=script&lang=js"
export * from "./GroupedLabelItem.vue?vue&type=script&lang=js"
import style0 from "./GroupedLabelItem.vue?vue&type=style&index=0&id=6d19f508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19f508",
  null
  
)

export default component.exports